import { baseApi } from './baseApi'
import {
  BillingProcedureItem,
  BillingProceduresList,
} from 'ts-back-end/src/business/billing-procedures/dto/billing-procedures-list.dto'
import { CreateBillingProcedureDto } from 'ts-back-end/src/business/billing-procedures/dto/create-billing-procedure.dto'

export const billingProceduresApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createBillingProcedure: builder.mutation<{ message: string }, CreateBillingProcedureDto>({
      query: (body) => ({ url: `/lab/billing/procedures`, method: 'POST', body }),
      invalidatesTags: ['BillingProcedures'],
    }),
    getBillingProceduresList: builder.query<
      BillingProceduresList,
      { [key: string]: string | number }
    >({
      query: (query) => ({ url: `/lab/billing/procedures`, params: query }),
    }),
    getAllBillingProceduresList: builder.query<BillingProcedureItem[], {}>({
      query: (query) => ({ url: `/lab/billing/procedures/all` }),
    }),
    getBillingProcedure: builder.query<BillingProcedureItem, { id: string }>({
      query: ({ id }) => ({ url: `/lab/billing/procedures/${id}` }),
    }),
    updateBillingProcedure: builder.mutation<BillingProcedureItem, Partial<BillingProcedureItem>>({
      query: ({ id, ...data }) => ({
        method: `PATCH`,
        url: `/lab/billing/procedures/${id}`,
        body: data,
      }),
      invalidatesTags: ['BillingProcedures'],
    }),
  }),
})

export const {
  useGetBillingProceduresListQuery,
  useGetAllBillingProceduresListQuery,
  useLazyGetBillingProceduresListQuery,
  useGetBillingProcedureQuery,
  useLazyGetBillingProcedureQuery,
  useCreateBillingProcedureMutation,
  useUpdateBillingProcedureMutation,
} = billingProceduresApi
